import React, { Component } from "react";
import axios from "axios";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import swal from 'sweetalert2';
import "./index.css";
import { manageBatchActions } from "../../../_actions/organisations/manageBatchList.action";
import { connect } from "react-redux";

class DeleteModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: props.showModal,
      modalData: props.modalData,
      fade: true,
      deleteData: [],
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    if (this.props.toggleModal) {
      this.props.toggleModal(!this.state.modal);
    }
    this.setState({
      modal: !this.state.modal,
    });
  }

  componentDidMount() {
    var data = this.props.formData.map(function(item) {
      return item.email;
    });
    this.setState({ deleteData: data });

    localStorage.setItem("emailData", JSON.stringify(data));
  }

  handledeleteEmail() {
    var emailData = JSON.parse(localStorage.getItem("emailData") || "[]");
    
    axios
      .post("/users/emails/delete/", { emails: emailData })
      .then(function(response) {
        localStorage.removeItem("emailData");
        var message = response.data[0];
        var deletedCount = message.deleted.length;
        var notDeletedCount = message.not_deleted.length;
        
        var resultMessage = deletedCount + " email(s) deleted successfully. ";
        if (notDeletedCount > 0) {
          resultMessage += notDeletedCount + " email(s) could not be deleted due to permissions.";
        }
        
        swal({
          title: 'Operation Complete',
          text: resultMessage,
          type: 'info',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        }).then(function() {
          var orgId = this.props.orgId;
          var sellerId = this.props.sellerId;
          var dispatch = this.props.dispatch;
          dispatch(manageBatchActions.getParticipantsListAction({ orgId: orgId, sellerId: sellerId }));
        }.bind(this));
      }.bind(this))
      .catch(function(err) {
        var errorMessage = 'An error occurred';
        if (err.response && err.response.data) {
          errorMessage = err.response.data.KeyError || err.response.data.message || errorMessage;
        }
        swal({
          title: 'Error',
          text: errorMessage,
          type: 'error',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        });
      });
  }

  render() {
    return (
      <div className="deleteModalWrapper">
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={this.props.className}
          style={{ maxWidth: "600px" }}
          centered
        >
          <ModalHeader
            toggle={this.toggle}
            className="bg-black text-white text-uppercase custom-header"
          >
            DELETE PARTICIPANTS
          </ModalHeader>
          <ModalBody>
            <div className="text-center">
              <p>Are you sure you want to delete the following {this.state.deleteData.length} participant(s)?</p>
              <ul className="list-unstyled">
                {this.state.deleteData.map(function(email, index) {
                  return <li key={index}>{email}</li>;
                })}
              </ul>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button onClick={this.toggle}>No, Keep it</Button>
            <Button
              type="submit"
              className="deleteButton"
              onClick={function() {
                this.handledeleteEmail();
                this.toggle();
              }.bind(this)}
            >
              Yes, delete it!
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    dispatch: state.dispatch,
  };
}

export default connect(mapStateToProps)(DeleteModal);


// WEBPACK FOOTER //
// ./src/_components/common/DeleteModal/index.jsx